import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import {
  Box,
  Flex,
  Heading,
  HStack,
  Image,
  Progress,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import Slider from 'react-slick'

import { OdontoIcon } from '../../../assets/icons/OdontoIcon'
import { SaudeIcon } from '../../../assets/icons/SaudeIcon'
import { VidaIcon } from '../../../assets/icons/VidaIcon'
import { AccessModal } from '../../../components/widgets/AccessModal'
import ChakraCarousel from '../../../components/widgets/ChakraCarousel'
import { apiSensedia } from '../../../services/api-sensedia'

type Props = {
  totalFaturamentoMes: number
  setTotalFaturamentoMes: React.Dispatch<React.SetStateAction<number>>
}

export const Products = ({ totalFaturamentoMes, setTotalFaturamentoMes }: Props) => {
  const toast = useToast()

  const { isOpen, onOpen, onClose } = useDisclosure()

  const [isLoading, setIsLoading] = useState(false)

  const [dashType, setDashType] = useState<'yearValue' | 'monthValue'>('yearValue')

  const [cardsProdutos, setCardsProdutos] = useState([
    {
      type: '',
      monthValue: 0,
      yearValue: 0,
      icon: '',
      monthRepres: 0,
      yearRepres: 0,
    },
  ])

  const [totalFaturamentoAno, setTotalFaturamentoAno] = useState(0)

  const handleChangeDashType = (value: 'yearValue' | 'monthValue') => {
    setDashType(value)
  }

  const handleIcon = (type: string) => {
    switch (type) {
      case 'Saúde':
        return <SaudeIcon w="5rem" h="6rem" />
      case 'Odonto':
        return <OdontoIcon w="5.5rem" h="6rem" />
      case 'Vida':
        return <VidaIcon w="6rem" h="6rem" />
      case 'Previdência':
        return <Image w="6.37rem" h="6rem" src={'/images/icons/Previdencia2x.svg'} />
      default:
        return ''
    }
  }

  const getData = async () => {
    try {
      const { data } = await apiSensedia.get('/assessorias/produtos')

      setTotalFaturamentoAno(data.total_faturamento)

      const faturamentoMes = data.produtos.reduce((prev, curr) => {
        return prev + curr.premio_emitido_mes
      }, 0)
      setTotalFaturamentoMes(faturamentoMes)

      const cards = data.produtos.map(produto => {
        const productsMap = {
          SAUDE: {
            type: 'Saúde',
            icon: 'icone saude',
          },
          ODONTO: {
            type: 'Odonto',
            icon: 'icone odonto',
          },
          VIDA: {
            type: 'Vida',
            icon: 'icone vida',
          },
          PREVIDENCIA: {
            type: 'Previdência',
            icon: 'icone outros',
          },
        }
        const representacao_mes = faturamentoMes ? produto.premio_emitido_mes / faturamentoMes : 0

        const representacao_ano = data.total_faturamento ? produto.premio_emitido_ano / data.total_faturamento : 0

        return {
          ...productsMap[produto.produto],
          monthValue: produto.premio_emitido_mes,
          yearValue: produto.premio_emitido_ano,
          monthRepres: representacao_mes,
          yearRepres: representacao_ano,
        }
      })
      setCardsProdutos(cards)
    } catch (error: any) {
      console.log(error)

      if (error?.response?.status === 401) {
        onOpen()
        return
      }

      toast({
        position: 'top',
        description: error.response?.data,
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    }
  }

  useEffect(() => {
    setIsLoading(true)

    getData()

    setIsLoading(false)
  }, [])

  return (
    <Box w="100%" marginBottom={{ base: '4.2rem', md: '0' }}>
      <Box w="100%" display="flex" justifyContent="flex-end">
        <HStack justify="space-between" w="100%">
          <Heading fontSize="2rem">Painel de Vendas</Heading>
          <Text color="#001E64" p=".7rem 1rem" border=".5px solid" borderRadius="2rem" bg="#fff">
            {dashType === 'yearValue' ? <span>Total de faturamento: </span> : <span>Total de faturamento/mês: </span>}
            <b>
              {dashType === 'monthValue'
                ? totalFaturamentoMes.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : totalFaturamentoAno.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </b>
          </Text>
        </HStack>
      </Box>

      {isLoading ? (
        <Flex w="100%" justify="center" align="center">
          <Spinner mt="10rem" />
        </Flex>
      ) : (
        <>
          <RadioGroup
            colorScheme="facebook"
            position="absolute"
            mt="34px"
            onChange={(value: 'yearValue' | 'monthValue') => handleChangeDashType(value)}
            value={dashType}
          >
            <HStack spacing="2rem">
              <Radio value="yearValue" borderColor="#001E64">
                Produção anual
              </Radio>
              <Radio value="monthValue" borderColor="#001E64">
                Produção mensal
              </Radio>
            </HStack>
          </RadioGroup>

          <Box display={{ base: 'none', md: 'block' }}>
            {cardsProdutos.length > 1 ? (
              <ChakraCarousel display="flex" gap={30} flexDir="column">
                {cardsProdutos.map((item, index) => (
                  <Box
                    key={index}
                    w="50rem"
                    h="13rem"
                    bg="#fff"
                    boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                    borderRadius="2rem"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDir="column"
                  >
                    <Box w="90%" display="flex" justifyContent="flex-start" flexDir="column">
                      <Box display="flex" justifyContent="space-between">
                        <Box>
                          <Text fontWeight="bold" fontSize="1.5rem">
                            <Box display="flex" alignItems="center" gap=".3rem">
                              {item.type}
                              <Tooltip
                                label={
                                  item.type === 'Previdência' ? (
                                    <Stack>
                                      <Text>Estes valores compreendem a(s) carteira(s):</Text>
                                      <Text>• Previdência Individual</Text>
                                    </Stack>
                                  ) : item.type === 'Vida' ? (
                                    <Stack>
                                      <Text>Estes valores compreendem a(s) carteira(s):</Text>
                                      <Text>• Vida Individual</Text>
                                      <Text>• Vida Coletivo</Text>
                                    </Stack>
                                  ) : item.type === 'Saúde' ? (
                                    <Stack>
                                      <Text>Estes valores compreendem a(s) carteira(s):</Text>

                                      <Text>• Saúde PME</Text>
                                      <Text>• Saúde Empresarial</Text>
                                    </Stack>
                                  ) : item.type === 'Odonto' ? (
                                    <Stack>
                                      <Text>Estes valores compreendem a(s) carteira(s):</Text>

                                      <Text>• Odonto Individual</Text>
                                      <Text>• Odonto Empresarial</Text>
                                      <Text>• Odonto PME</Text>
                                    </Stack>
                                  ) : undefined
                                }
                                shouldWrapChildren
                              >
                                <AiOutlineInfoCircle size={25} />
                              </Tooltip>
                            </Box>
                          </Text>
                          <Text fontSize="1rem" pt="1rem">
                            Prêmio emitido
                          </Text>
                          <Text fontSize="1.25rem" fontWeight="bold" color="#146CFA">
                            {dashType === 'yearValue'
                              ? item.yearValue.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })
                              : item.monthValue.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                          </Text>
                        </Box>

                        {handleIcon(item.type)}
                      </Box>
                      {(item.yearRepres * 100 >= 1 && dashType === 'yearValue') ||
                      (item.monthRepres * 100 >= 1 && dashType === 'monthValue') ? (
                        <>
                          <Text fontSize="1rem" pt="1rem">
                            Representatividade na prod. total
                          </Text>
                          <Box display="flex" w="100%" justifyContent="space-between" alignItems="center">
                            <Progress
                              w="80%"
                              borderRadius="1rem"
                              value={dashType === 'yearValue' ? item.yearRepres * 100 : item.monthRepres * 100}
                            ></Progress>
                            <Text color="#828282" fontWeight="540">
                              {dashType === 'yearValue'
                                ? (item.yearRepres * 100).toFixed(1)[1] !== '.'
                                  ? (item.yearRepres * 100).toFixed(1)[0] + (item.yearRepres * 100).toFixed(1)[1]
                                  : (item.yearRepres * 100).toFixed(1)[0]
                                : (item.monthRepres * 100).toFixed(1)[1] !== '.'
                                ? (item.monthRepres * 100).toFixed(1)[0] + (item.monthRepres * 100).toFixed(1)[1]
                                : (item.monthRepres * 100).toFixed(1)[0]}
                              %
                            </Text>
                          </Box>
                        </>
                      ) : (
                        <Flex background={'#D3DEED'} padding={'1rem 0'} justify={'center'} borderRadius=".3rem">
                          <AiOutlineInfoCircle size={20} />
                          <Text marginLeft={'0.5rem'}>Representatividade menor que 1%</Text>
                        </Flex>
                      )}
                    </Box>
                  </Box>
                ))}
              </ChakraCarousel>
            ) : (
              <Box w="460px" h="288px" />
            )}
          </Box>

          {/** mobile slider */}
          <Box display={{ base: 'block', md: 'none' }} position="relative" top="6rem">
            <Slider arrows={false} dots={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1}>
              {cardsProdutos.map((item, index) => (
                <Box
                  key={index}
                  w="100%"
                  h="13rem"
                  bg="#fff"
                  boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
                  borderRadius="2rem"
                  display="flex !important"
                  alignItems="center"
                  justifyContent="center"
                  flexDir="column"
                >
                  <Box w="90%" display="flex" justifyContent="flex-start" flexDir="column">
                    <Box display="flex !important" justifyContent="space-between" alignItems="center">
                      <Box>
                        <Text fontWeight="bold" fontSize="1.5rem">
                          <Box display="flex" alignItems="center" gap=".3rem">
                            {item.type}
                            <Tooltip
                              label={
                                item.type === 'Previdência' ? (
                                  <Stack>
                                    <Text>Estes valores compreendem a(s) carteira(s):</Text>
                                    <Text>• Previdência Individual</Text>
                                  </Stack>
                                ) : item.type === 'Vida' ? (
                                  <Stack>
                                    <Text>Estes valores compreendem a(s) carteira(s):</Text>
                                    <Text>• Vida Individual</Text>
                                    <Text>• Vida Coletivo</Text>
                                  </Stack>
                                ) : item.type === 'Saúde' ? (
                                  <Stack>
                                    <Text>Estes valores compreendem a(s) carteira(s):</Text>

                                    <Text>• Saúde PME</Text>
                                    <Text>• Saúde Empresarial</Text>
                                  </Stack>
                                ) : item.type === 'Odonto' ? (
                                  <Stack>
                                    <Text>Estes valores compreendem a(s) carteira(s):</Text>

                                    <Text>• Odonto Individual</Text>
                                    <Text>• Odonto Empresarial</Text>
                                  </Stack>
                                ) : undefined
                              }
                              shouldWrapChildren
                            >
                              <AiOutlineInfoCircle size={25} />
                            </Tooltip>
                          </Box>
                        </Text>
                        <Text fontSize="1rem" pt="1rem">
                          Prêmio emitido
                        </Text>
                        <Text fontSize="1.25rem" fontWeight="bold" color="#146CFA">
                          {dashType === 'yearValue'
                            ? item.yearValue.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })
                            : item.monthValue.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                        </Text>
                      </Box>

                      {handleIcon(item.type)}
                    </Box>
                    {(item.yearRepres * 100 >= 1 && dashType === 'yearValue') ||
                    (item.monthRepres * 100 >= 1 && dashType === 'monthValue') ? (
                      <>
                        <Text fontSize="1rem" pt="1rem">
                          Representatividade na prod. total
                        </Text>
                        <Box display="flex" w="100%" justifyContent="space-between" alignItems="center">
                          <Progress
                            w="80%"
                            borderRadius="1rem"
                            value={dashType === 'yearValue' ? item.yearRepres * 100 : item.monthRepres * 100}
                          ></Progress>
                          <Text color="#828282" fontWeight="540">
                            {dashType === 'yearValue'
                              ? (item.yearRepres * 100).toFixed(1)[1] !== '.'
                                ? (item.yearRepres * 100).toFixed(1)[0] + (item.yearRepres * 100).toFixed(1)[1]
                                : (item.yearRepres * 100).toFixed(1)[0]
                              : (item.monthRepres * 100).toFixed(1)[1] !== '.'
                              ? (item.monthRepres * 100).toFixed(1)[0] + (item.monthRepres * 100).toFixed(1)[1]
                              : (item.monthRepres * 100).toFixed(1)[0]}
                            %
                          </Text>
                        </Box>
                      </>
                    ) : (
                      <Flex background={'#D3DEED'} padding={'1rem 0'} justify={'center'} borderRadius=".3rem">
                        <AiOutlineInfoCircle size={20} />
                        <Text marginLeft={'0.5rem'}>Representatividade menor que 1%</Text>
                      </Flex>
                    )}
                  </Box>
                </Box>
              ))}
            </Slider>
          </Box>
        </>
      )}
      <AccessModal isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}
